module.exports = __webpack_public_path__ + "img/play.fe9947d6.svg";